import React, {useContext, useEffect, useRef, useState} from "react";
import {BackendContext} from "../../../App";
import {
  Button, Divider,
  Input, InputNumber, InputNumberProps,
  InputRef, List,
  Modal,
  notification,
  Space,
  Spin,
  TableColumnsType,
  TableColumnType,
  TablePaginationConfig
} from "antd";
import {useNavigate} from "react-router-dom";
import {Paths} from "../../../Paths";
import {Messages} from "../../../backend/Messages";
import ClearBody from "../../../components/ClearBody";
import Title from "antd/es/typography/Title";
import PlayerInfoDTO from "../../../backend/models/player/PlayerInfoDTO";
import {ReloadOutlined, SearchOutlined} from '@ant-design/icons';
import {FilterDropdownProps} from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import {Select, Table} from "antd/lib";
import PaginationInfo from "../../../backend/models/PaginationInfo";
import PlayingPlayerRepresentationDTO from "../../../backend/models/player/PlayingPlayerRepresentationDTO";
import BreadcrumbSeparator from "antd/es/breadcrumb/BreadcrumbSeparator";
import Search, {SearchProps} from "antd/es/input/Search";
import { DefaultOptionType } from "antd/lib/select";



type NotificationType = 'success' | 'info' | 'warning' | 'error';

function parseToDefaultTypes(arr: string[]): DefaultOptionType[] {
  return arr.map((item) => ({ value: item, label: item }));
}

function SendNotificationToPlayerPage() {
  const backendContext = useContext(BackendContext);
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(true);

  const [expansionColors, setExpansionColors] = useState<DefaultOptionType[] | undefined>(undefined);
  const [expansionIcons, setExpansionIcons] = useState<DefaultOptionType[] | undefined>(undefined);
  const [playingPlayers, setPlayingPlayers] = useState<DefaultOptionType[] | undefined>(undefined);

  const [everStartedLoading, setEverStartedLoading] = useState(false);
  const [everFinishedLoading, setEverFinishedLoading] = useState(false);
  const [notificationIcon, setNotificationIcon] = useState("");
  const [notificationColor, setNotificationColor] = useState("");
  const [notificationBohId, setNotificationBohId] = useState("");
  const [notificationTitle, setNotificationTitle] = useState("");
  const [notificationText, setNotificationText] = useState("");
  const [notificationDuration, setNotificationDuration] = useState(2);


  const openNotificationWithIcon = (type: NotificationType, title: string, description: string) => {
    api[type]({
      message: title,
      description: description,
    });
  };

  const startLoadingPublicData = () =>{
    backendContext.getExpansionIcons().then((icons) => {
      console.log(`Loaded icons: ${icons.length}`);
      setExpansionIcons(parseToDefaultTypes(icons));
    }).catch((error) => {
      openNotificationWithIcon("error", Messages.UnknownErrorTitle, Messages.UnknownErrorDescription + " " + JSON.stringify(error));
    });

    backendContext.getExpansionColors().then((colors) => {
      console.log(`Loaded colors: ${colors.length}`);
      setExpansionColors(parseToDefaultTypes(colors));
    }).catch((error) => {
      openNotificationWithIcon("error", Messages.UnknownErrorTitle, Messages.UnknownErrorDescription + " " + JSON.stringify(error));
    });
  }

  useEffect(() => {
    if (! backendContext.hasPlayerAuth()) {
      navigate(Paths.LoginSteamPage);
    }

    if (! everStartedLoading) {
      startLoadingPublicData();
      setEverStartedLoading(true);
    }

    if (!everFinishedLoading && expansionColors !== null && expansionIcons !== null) {
      setIsModalOpen(false);
      setEverFinishedLoading(true)
    }
  }, [backendContext, everFinishedLoading, everStartedLoading, expansionColors, expansionIcons, navigate, startLoadingPublicData]);

  const clickedReloadPlayers = () => {
    backendContext.getPlayingPlayers().then((playingPlayersResponse) => {
      const treatPlayers: DefaultOptionType[] = playingPlayersResponse.playingPlayers.map((item) => ({ value: item.bohemianID, label: item.profileName }));
      setPlayingPlayers(treatPlayers);

    }).catch((error) => {
      openNotificationWithIcon("error", Messages.UnknownErrorTitle, Messages.UnknownErrorDescription + " " + JSON.stringify(error));
    });
  }

  const clickedSend = () => {
    setIsModalOpen(true);
    backendContext.sendNotificationToPlayer(notificationBohId, notificationTitle, notificationText, notificationIcon, notificationColor, notificationDuration).then((playingPlayersResponse) => {
      setNotificationTitle("");
      setNotificationText("");
      setIsModalOpen(false);

    }).catch((error) => {
      openNotificationWithIcon("error", Messages.UnknownErrorTitle, Messages.UnknownErrorDescription + " " + JSON.stringify(error));
    });
  }

  const onChangeNotificationTitle = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setNotificationTitle(e.target.value);
  const onChangeNotificationText = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setNotificationText(e.target.value);
  const handleChangeIcon = (value: string) => {
    setNotificationIcon(value);
  };
  const handleChangeColor = (value: string) => {
    setNotificationColor(value);
  };
  const handleChangePlayerBohId = (value: string) => {
    setNotificationBohId(value);
  };
  const onChangeDuration: InputNumberProps['onChange'] = (value) => {
    setNotificationDuration(value as number);
  };

  return (
    <>
      {contextHolder}
      <ClearBody content={
        <div>
          <Title>Player notifications</Title>
          <br />

          <Button type="primary" shape="circle" icon={<ReloadOutlined />} style={{marginBottom: 10, marginRight: 10}} onClick={clickedReloadPlayers} />
          <Select placeholder={"Notification for player"} onChange={handleChangePlayerBohId} options={playingPlayers} style={{ width: 500, marginBottom: 10 }}/>
          <Divider />

          <Select placeholder={"Notification icon"} onChange={handleChangeIcon} options={expansionIcons} style={{ width: 500, marginBottom: 10, marginRight: 10 }}/>
          <Select placeholder={"Notification color"} onChange={handleChangeColor} options={expansionColors} style={{ width: 500 }}/>
          <Divider />

          <Input placeholder="Notification title" onChange={onChangeNotificationTitle} value={notificationTitle} style={{width: 550, marginBottom: 10}} />
          <Input placeholder="Notification text" onChange={onChangeNotificationText} value={notificationText} style={{marginBottom: 10}} />
          <InputNumber min={1} max={10} defaultValue={notificationDuration} onChange={onChangeDuration} />
          <Divider />

          <Button type="primary" style={{backgroundColor: "red"}} onClick={clickedSend}>Send</Button>
          <Divider />


          <Modal open={isModalOpen} centered={true} closable={false}
                 okButtonProps={{ style: { display: 'none' } }}
                 cancelButtonProps={{ style: { display: 'none' } }}
          >
            <div style={{textAlign: "center"}}>
              <Spin size="large" />
            </div>
          </Modal>

        </div>
      } />
    </>
  );
}

export default SendNotificationToPlayerPage;